import { axiosInstance } from "./index";
import { TokenStorage } from "./tokenStorage";
import type { User } from "./user";
import type { ClientInvitation } from "@/shared/types/campaign/types";

export const clientInvitationApi = {
	// Agency view of the Clients table: open (invited / expired) invitations.
	list: async (campaignId: string): Promise<ClientInvitation[]> =>
		(await axiosInstance.get(`/campaign/${campaignId}/client-invitations`)).data.invitations,
	resend: async (campaignId: string, invitationId: string): Promise<{ expiresAt: string }> =>
		(await axiosInstance.post(`/campaign/${campaignId}/client-invitations/${invitationId}/resend`)).data,
	resolve: async (
		token: string,
	): Promise<{ campaignName: string; accountState: "new" | "existing"; email: string }> =>
		(await axiosInstance.get(`/client-invitations/${encodeURIComponent(token)}`)).data,
	register: async (
		token: string,
		payload: Record<string, unknown>,
	): Promise<{ user: User; accessToken: string; sessionExpiresAt?: string; campaignId: string }> => {
		const response = await axiosInstance.post(`/client-invitations/${encodeURIComponent(token)}/register`, payload);
		TokenStorage.setAccessToken(response.data.accessToken);
		TokenStorage.setSessionExpiresAt(response.data.sessionExpiresAt);
		return response.data;
	},
	accept: async (token: string): Promise<{ campaignId: string }> =>
		(await axiosInstance.post(`/client-invitations/${encodeURIComponent(token)}/accept`)).data,
};
